import React from 'react';
import Button from '../Button';
import { RiDeleteBack2Fill } from 'react-icons/ri';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalContent,
  TextArea,
  ButtonsContainer,
  CloseButton,
} from './styles';

interface ObservationModalProps {
  isOpen: boolean;
  onClose: () => void;
  observation: string;
  onSave: () => void;
  setObservation: (observation: string) => void;
}

const ObservationModal: React.FC<ObservationModalProps> = ({
  isOpen,
  onClose,
  observation,
  onSave,
  setObservation,
}) => {

  if (!isOpen) return null;

  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <h2>Adicionar Observação</h2>
          <CloseButton onClick={onClose}>
            <RiDeleteBack2Fill color="#777" size={18} />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <TextArea
            value={observation}
            onChange={e => setObservation(e.target.value)}
            placeholder="Exemplo: Corte fino / sem gordura"
          />
          <ButtonsContainer>
            <Button button={{ type: 'button' }} onClick={handleSave}>
              ADICIONAR
            </Button>
          </ButtonsContainer>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ObservationModal;
